import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { UserRoles } from 'src/app/constants/app.constants';
import { RegistrationService } from 'src/app/registration/registration.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-concession-company-data',
  templateUrl: './concession-company-data.component.html',
  styleUrls: ['./concession-company-data.component.scss'],
})
export class ConcessionCompanyDataComponent extends DestroyableComponent implements OnInit {
  form: FormGroup = this.registrationService.companyDataFG;

  @Input() companyId: string;
  @Input() autosave: boolean;
  @Input() readonly: boolean = false;
  @Input() updateOnConcessionValidationFormChange: boolean = true;
  @Output() companyCreated: EventEmitter<{ companyId: string }> = new EventEmitter<{ companyId: string }>();

  showBaseDataEmail: boolean = this.environmentService.showBaseDataEmail;
  showMainBusinessesPartTimeRadioBtn: boolean = this.environmentService.showMainBusinessesPartTimeRadioBtn;
  showInAuxiliaryOperationRadioBtn: boolean = this.environmentService.showInAuxiliaryOperationRadioBtn;
  showCompanyDescription: boolean = false;

  constructor(
    private registrationService: RegistrationService,
    private environmentService: EnvironmentService,
    private userService: UserService
  ) {
    super();
    this.showCompanyDescription =
      this.environmentService.showCompanyDescription && this.userService.getUserRole() === UserRoles.standardTechnician;
  }

  ngOnInit(): void {
    if (!this.environmentService.showBaseDataEmail) {
      this.form.controls.email.disable();
    }
  }

  updateCompany(options: { isFromAutosave: boolean }): Promise<void> {
    if ((options.isFromAutosave && !this.autosave) || !this.updateOnConcessionValidationFormChange) return;

    if (this.companyId) {
      const company = this.form.value;
      company.headoffice = company.headsubsidiary === 'hauptbetrieb' ? 'true' : 'false';
      company.subsidiary = company.headsubsidiary === 'nebenbetrieb' ? 'true' : 'false';
      company.main_businesses_part_time = company.headsubsidiary === 'main_businesses_part_time' ? 'true' : 'false';
      company.in_auxiliary_operation = company.headsubsidiary === 'in_auxiliary_operation' ? 'true' : 'false';
      company.company_id = this.companyId;
      const updateData = {
        company: [company],
      };
      this.preventLeak(this.registrationService.updateCompany(updateData, this.companyId)).subscribe(() => {
        return Promise.resolve();
      });
    } else {
      return this.saveNewCompany();
    }
  }

  saveNewCompany(): Promise<void> {
    const company = this.form.value;
    company.headoffice = company.headoffice === 'hauptbetrieb' ? 'true' : 'false';
    company.subsidiary = company.subsidiary === 'nebenbetrieb' ? 'true' : 'false';
    company.main_businesses_part_time = company.main_businesses_part_time === 'main_businesses_part_time' ? 'true' : 'false';
    company.in_auxiliary_operation = company.in_auxiliary_operation === 'in_auxiliary_operation' ? 'true' : 'false';
    const companyData = {
      company: [company],
    };

    return new Promise((resolve, reject) => {
      this.preventLeak(this.registrationService.saveCompany(companyData)).subscribe((savedCompany: any) => {
        if (savedCompany && savedCompany.created && savedCompany.created.length) {
          this.companyId = savedCompany.created[0].company_id;
          this.companyCreated.emit({ companyId: this.companyId });
          return resolve();
        }

        return reject();
      });
    });
  }
}
